import { gql } from '@apollo/client';

// use this for jsut names of things
export const MINIMUM_SEARCH_QUERY = gql`
query search($types: [ES_SearchOptionsTypesEnum!], $query: String, $page: Int, $limit: Int, $sort: ES_SearchOptionsSortEnum, $order: ES_SearchOptionsOrderEnum, $personId: UUID, $localeCode: ES_SearchOptionsLocaleCodeEnum, $categoryId: UUID, $_ids: [UUID!]) {
    search(searchOptions: {types: $types, query: $query, page: $page, limit: $limit, sort: $sort, order: $order, personId: $personId, localeCode: $localeCode, categoryId: $categoryId, _ids: $_ids}) {
      totalCount
      searchOptions {
        page
        limit
      }
      edges {
        node {
          __typename
          ... on ES_Curriculum {
            curriculumId
            name {
              locale
              content
            }
          }
          ... on ES_Course {
            courseId
            name {
              locale
              content
            }
          }
          ... on ES_Resource {
            resourceId
            isPublished
            name {
              locale
              content
            }
            resourceLocalizations {
              resourceLocalizationId
              name
              description
              localeCode
              isDefault
            }
          }
          ... on ES_Notification {
            notificationId
            name {
              locale
              content
            }
          }
        }
      }
    }
  }
`;

// ES_SearchOptionsTypesEnum: ['curricula','courses','resources']
// ES_SearchOptionsSortEnum: ['name', 'createdAt', 'updatedAt']
// ES_SearchOptionsOrderEnum: ['asc', 'desc']